<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>Tamanho (px)</label>
        <b-input class="input-pentagro" v-model="size"></b-input>
      </div>
      <div>
        <label>Rotação (°)</label>
        <b-input 
          class="input-pentagro"
          type="number" 
          v-model="rotate"
          min="0.00"
          max="360.00"
          step="0.1"
        ></b-input>
      </div>

      <div>
        <label for="color">Cor</label>
        <b-form-select class="input-pentagro" v-model="color" name="color" id="color">
          <b-form-select-option 
            v-for="(c, i) in colorKeys" 
            :key="c"
            :value="colors[c]"
          >
            {{(i+1)+"-"+c}}
          </b-form-select-option>
        </b-form-select>
      </div>

    </b-form>
  </div>
</template>

<script>
import { COLORS } from '../../utils/colors'

  export default {
    props: {
      node: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
       colorKeys: Object.keys(COLORS).sort(),
       colors: COLORS,
       size: parseFloat(this.node.size) / 50,
       rotate: this.node.rotate,
       color: this.node.color,
      }
    },

    watch:{
      size() { this.node.size = parseFloat(this.size) * 50 },
      rotate() { this.node.rotate = this.rotate > 360 ? 360 : this.rotate },
      color() { this.node.color = this.color }

    },

    mounted(){ }
  }
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}
</style>